import { activities, favorites, todo, visits } from "modules/app/utils";

const filters = [
  {
    label: "totalVisits",
    checkMatch: visits,
  },
  {
    label: "totalActivities",
    checkMatch: activities,
  },
  {
    label: "totalFavorites",
    checkMatch: favorites,
  },
  {
    label: "totalTodo",
    checkMatch: todo,
  },
];

const countTotal = (tab) =>
  tab.reduce((total, item) => (total += item.items.length), 0);

const matchTabs = (contact) => {
  const match = ["totalAll"];

  filters.forEach((filter) => {
    const tab = filter.checkMatch([contact]);
    const total = countTotal(tab);

    if (total > 0) {
      match.push(filter.label);
    }
  });

  return match;
};

export function addCountTabs(contact, state) {
  const tabs = matchTabs(contact);
  let newCountTabs = {};

  tabs.forEach((key) => {
    const newTotal = parseInt(state.totals[key]) + 1;
    newCountTabs[key] = String(newTotal);
  });
  return newCountTabs;
}

export function removeCountTabs(contact, state) {
  const tabs = matchTabs(contact);
  let newCountTabs = {};

  tabs.forEach((key) => {
    const newTotal = parseInt(state.totals[key]) - 1;
    newCountTabs[key] = String(newTotal);
  });

  return newCountTabs;
}

export function removeAndAddCountTabs(oldContact, newContact, state) {
  let newCountTabs = {};

  matchTabs(oldContact).forEach((key) => {
    const newTotal = parseInt(state.totals[key]) - 1;
    newCountTabs[key] = String(newTotal);
  });

  matchTabs(newContact).forEach((key) => {
    const newTotal = parseInt(newCountTabs[key] || state.totals[key]) + 1;
    newCountTabs[key] = String(newTotal);
  });

  return newCountTabs;
}

export const updatedState = (state, updateTabs, newContacts) => ({
  ...state,
  ...updateTabs,
  totals: {
    ...state.totals,
    ...updateTabs,
  },
  contacts: newContacts,
});
